export const data = [
  {
    title: 'projecting',
    description: 'projectingText',
    image: 'https://proeng.am/assets/renderForest.jpg',
  },
  {
    title: 'installation',
    description: 'installationText',
    image: 'https://proeng.am/assets/installation.jpg',
  },
  {
    title: 'bim',
    description: `bimText`,
    image: 'https://proeng.am/assets/bim.jpg',
  },
]
